import React from "react";
import TeamsApp from "./TeamsApp";
import WebApp from "./WebApp";

function App() {
  const inTeams = typeof window !== "undefined" && window.self !== window.top;
  return inTeams ? <TeamsApp /> : <WebApp />;
}

export default App;
